Auth = require 'app/scripts/db/auth'
ApiPromise = require 'app/scripts/network/api-promise'
Backgrounds = require 'app/scripts/data/backgrounds'
Dialog = require 'app/scripts/views/lib/dialog'
l = require 'app/scripts/lib/localize'
React = require 'react'
{ track, trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
t = require('app/scripts/views/internal/recup-with-helpers')('board_background_prompt')
{ unsplashClient } = require '@trello/unsplash'
PhotoAttributionComponent = require 'app/scripts/views/board-create/photo-attribution-component'
xtend = require 'xtend'

class BoardBackgroundPrompt extends React.Component
  displayName: 'BoardBackgroundPrompt'

  constructor: (props) ->
    super(props)

    @state = {
      loading: true
      image: null
      uploading: false
      isDemoing: false
    }

  UNSAFE_componentWillMount: ->
    unsplashClient.getPhoto('PdGBci-4jR8')
      .then((image) =>
        @setState({ image, loading: false, })
      )
      .catch((err) => {
        # Just dont show the popover
      })

  onTry: ->
    { model } = @props
    { image } = @state
    track('Board Menu', 'Change Background', "unsplash-#{image.id}")
    trackUe('Board Background Prompt', 'Try Background')
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      # track interaction with the prompt
      Analytics.sendClickedButtonEvent
        buttonName: 'tryBackgroundButton'
        source: 'boardBackgroundPromptInlineDialog'
        attributes:
          backgroundId: "unsplash-#{image.id}"

      # track background change
      Analytics.sendUpdatedBoardFieldEvent
        field: 'background',
        value: "unsplash-#{image.id}",
        source: 'boardBackgroundPromptInlineDialog',
        containers:
          board:
            id: model.id
        attributes:
          backgroundType: 'photo'

    unsplashClient.trackDownload(image)

    @setState({ uploading: true, })

    ApiPromise(
      url: "/1/boards/#{model.attributes.id}/prefs/background"
      type: 'post'
      data:
        url: unsplashClient.appendImageParameters(image.urls.raw)
    ).finally(=>
      @setState({ uploading: false, isDemoing: true, })
    )

  onKeep: ->
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Keep photo')
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendClickedButtonEvent
        buttonName: 'keepPhotoButton'
        source: 'boardBackgroundPromptInlineDialog'
    @props.onDismiss()

  onBrowse: ->
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Browse')
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendClickedButtonEvent
        buttonName: 'browseButton'
        source: 'boardBackgroundPromptInlineDialog'
    @props.onBrowse()

  onCancel: ->
    { model, onDismiss } = @props
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Cancel')
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendClickedButtonEvent
        actionSubjectId: 'cancelButton'
        source: 'boardBackgroundPromptInlineDialog'

    background = model.viewState.get('initialBackgroundColor') || 'blue'
    model
      .set
        prefs:
          background: background
          backgroundColor: Backgrounds[background].color
          backgroundBrightness: Backgrounds[background].brightness
          backgroundImage: null
          backgroundImageScaled: null
      .setPref 'background', background

    Analytics.sendUpdatedBoardFieldEvent
      field: 'background',
      value: background,
      source: 'boardBackgroundPromptInlineDialog',
      containers:
        board:
          id: model.id
      attributes:
        backgroundType: 'color'

    onDismiss()

  render: t.renderable ->
    if @state.loading
      return t.div '.board-background-prompt-noop'

    { image, uploading, isDemoing } = @state

    t.div '.board-background-prompt', =>
      t.div '.board-background-prompt--image', {
        style: {
          backgroundImage: "url(#{image.urls.small})"
        }
      }, =>
        if uploading
          t.addElement(
            React.createElement(
              'div',
              { className: 'uploading' },
              React.createElement(
                'span',
                { className: 'spinner small u-float-left' }
              ),
              l(['templates', 'board_background_selection', 'uploading-ellipsis'])
            )
          )
        else
          t.createElement PhotoAttributionComponent,
            user: image.user
            active: true
      t.div '.board-background-prompt--inner', =>
        t.h4 =>
          t.format 'add-some-pizzazz'
        if !isDemoing
          t.button '.primary.board-background-prompt--item', {
            onClick: => @onTry()
          }, =>
            t.format 'give-it-a-try'
        else
          t.button '.primary.board-background-prompt--item', {
            onClick: => @onKeep()
          }, =>
            t.format 'keep-this-photo'
        t.button '.board-background-prompt--item', {
          onClick: => @onBrowse()
        }, =>
          t.format 'browse-more'
        t.a '.board-background-prompt--item', {
          onClick: => @onCancel(),
          href: '#'
        }, =>
          if isDemoing
            t.format 'cancel-keep-my-background'
          else
            t.format 'no-thanks-dismiss'

module.exports = BoardBackgroundPrompt
